import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { API } from "../../helpers/constants";
import { handleAxiosErrors } from "../../helpers/errorHandling";
import { printFile } from "../../helpers/fileHandle";
import { EXHIBITION } from "../../locales/components/namespaces";
import useUserData from "../user/useUserData";

const useFetchBadgesAndPrintToPdf = () => {
	const { t } = useTranslation(EXHIBITION)
	const { token } = useUserData()
	const [loading, setLoading] = useState(false)
	
	const fetchBadgesAndPrintToPdf = useCallback(({
													  printSize = 1,
													  params = {},
													  type = 'partner',
												  }) => {
		setLoading(true)
		axios({
			method: 'POST',
			headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${token}` },
			url: `${API}/en/${type}/badge/${printSize}`,
			responseType: 'blob',
			data: {
				...params,
			}
		}).then(response => {
			const blob = new Blob([response.data], { type: 'application/pdf' });
			const url = window.URL.createObjectURL(blob);
			printFile(url)
			setLoading(false)
		}).catch(error => {
			setLoading(false)
			enqueueSnackbar(handleAxiosErrors(error, t('Failed to print badge!')), {
				variant: 'warning',
			})
		})
	}, [t, token])
	
	return {
		loading,
		fetchBadgesAndPrintToPdf
	}
}

export default useFetchBadgesAndPrintToPdf